export default {
    bindings: {
        activity: '=',
        title: '@'
    },
    controller: 'activitySaveController',
    template: require('../views/activity.save.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/activity/components/activity.save.component.js